export default __webpack_public_path__ + "static/media/StepOne.2842f2c9.png";